import React, { useRef, useEffect } from "react";

import "./Map.css";
const Map = (props) => {
  const mapRef = useRef();
  //creating map object that will be using ref passed below
  const { zoom, center } = props;
  useEffect(() => {
    const map = new window.google.maps.Map(mapRef.current, {
      center: props.center,
      zoom: props.zoom,
    });

    //creating marker
    new window.google.maps.Marker({ position: props.center, map: map });
  }, [zoom, center]);

  return <div ref={mapRef} className={`map ${props.mapClassName}`}></div>;
};

export default Map;
